<div app-kirjanpito-projektien-tyylit [kirjanpidonProjektitObservable]="kirjanpidonProjektitObservable"></div>

<div style="height: 40px; background-color: rgb(62, 203, 244); color: white; line-height: 40px; text-align: center; font-size: 20px">
  {{ asiakkaanTiedotObservable | async }}
</div>

<div app-kirjanpito-raportit (kirjaustaKlikattiin)="raporttikirjaustaKlikatiin($event)" (selectedReportTypeChanged)="selectedReportTypeChanged($event)" [valittuKuukausiObservable]="valittuKuukausiObservable" [valittuValilehti]="valittuValilehti"></div>
